import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";

// Ativa logs detalhados em produção para depuração
if (import.meta.env.PROD) {
  console.log("🚀 App iniciado em modo de produção");
  
  // Sobrescreve console.error para garantir que erros sejam visíveis
  const originalError = console.error;
  console.error = (...args) => {
    // Aqui poderíamos enviar para um serviço de monitoramento (Sentry, etc)
    originalError.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    console.error("❌ Erro global capturado:", event.error || event.message);
    const debugDiv = document.getElementById('debug-error');
    if (debugDiv) {
      debugDiv.innerHTML = 'Erro de execução: ' + (event.error?.message || event.message);
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    console.error("⚠️ Promessa rejeitada não tratada:", event.reason);
  });
}

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Elemento root não encontrado no DOM");

  createRoot(rootElement).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
  console.log("✅ Renderização inicial concluída");
} catch (error) {
  console.error("💥 Falha crítica na inicialização:", error);
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; color: #ef4444; font-family: sans-serif;">
        <h1>Erro Crítico</h1>
        <p>Não foi possível iniciar a aplicação.</p>
        <pre style="text-align: left; background: #f8fafc; padding: 10px; border-radius: 4px; overflow: auto; font-size: 12px;">${error instanceof Error ? error.stack : String(error)}</pre>
        <button onclick="window.location.reload()" style="padding: 10px 20px; cursor: pointer;">Recarregar</button>
      </div>
    `;
  }
}
